var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 267,
    height: 512,
    viewBox: "0 0 267 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.5 -0.5C197.167 -0.5 214.833 -0.5 232.5 -0.5C243.677 0.598822 255.011 1.59882 266.5 2.5C266.5 29.8333 266.5 57.1667 266.5 84.5C245.811 84.1949 225.144 84.6949 204.5 86C185.162 89.3408 174.995 100.841 174 120.5C173.5 142.497 173.333 164.497 173.5 186.5C203.5 186.5 233.5 186.5 263.5 186.5C259.669 217.147 256.002 247.814 252.5 278.5C226.167 278.5 199.833 278.5 173.5 278.5C173.5 356.167 173.5 433.833 173.5 511.5C141.833 511.5 110.167 511.5 78.5 511.5C78.5 433.833 78.5 356.167 78.5 278.5C52.5 278.5 26.5 278.5 0.5 278.5C0.5 247.833 0.5 217.167 0.5 186.5C26.5 186.5 52.5 186.5 78.5 186.5C78.116 157.146 78.616 127.812 80 98.5C88.488 40.5113 121.655 7.51131 179.5 -0.5Z",
    fill: "#000002"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.fad27c153998c5844965c9f7adf53d8c.svg";
export { ForwardRef as ReactComponent };